export const state = {
  corporations: [{}],
  addCorporation: {},
  updateCorporation: {},
  corporation: {},
  users: [],
  posts: [],
  callAppDefine: [{}],
  usageLogsAuditLog: [],
  usageLogsCallHistory: [],
  total: 0
}
export const mutations = {
  reversedPostsCheck(state, payload) {
    for (var i = 0; i < state.posts.length; i++) {
      if (state.posts[i].postId === payload.postId) {
        state.posts[i].checked = !state.posts[i].checked
        break
      }
    }
  },
  reversedUsersCheck(state, payload) {
    for (var i = 0; i < state.users.length; i++) {
      if (state.users[i].userId === payload.userId) {
        state.users[i].checked = !state.users[i].checked
        break
      }
    }
  },
  clearUserAndPostCheck(state) {
    for (let i = 0; i < state.users.length; i++) {
      state.users[i].checked = false
    }
    for (let i = 0; i < state.posts.length; i++) {
      state.posts[i].checked = false
    }
  },
  setCorporations(state, response) {
    if (response.data['data'] == null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
      if (!response.data['data'][i].availableDeviceCounts.match(/^[0-9]+$/)) {
        response.data['data'][i].availableDeviceCounts = 0
      }
    }
    state.corporations = response.data['data']
    state.total = response.data['header']['total']
  },
  setDetail(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    if (!response.data['data'][0].availableDeviceCounts.match(/^[0-9]+$/)) {
      response.data['data'][0].availableDeviceCounts = 0
    }
    state.corporation = response.data['data'][0]
    state.updateCorporation = {}
    state.updateCorporation.adminUsers = [{}]
  },
  inputUpdate(state, payload) {
    state.updateCorporation[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addCorporation[payload.name] = payload.value
  },
  inputAddUpdateAdminUser(state, payload) {
    state.addCorporation.adminUsers[0][payload.name] = payload.value
  },
  inputUpdateAdminUser(state, payload) {
    state.updateCorporation.adminUsers[0][payload.name] = payload.value
  },
  assignFromAddToDetail(state) {
    state.corporation = Object.assign({}, state.addCorporation)
  },
  clearCorporation(state) {
    state.addCorporation = {}
    state.addCorporation.autoLogoutEnableFlag = true
    state.addCorporation.passwordEnableFlag = true
    state.addCorporation.autoLogoutSecond = 3600
    state.addCorporation.availableDeviceCounts = 0
    state.addCorporation.locationInfoEnableFlag = true
    state.addCorporation.gpsEnableFlag = true
    state.addCorporation.mailTargetFlag = true
    state.addCorporation.ratingQuarityEnableFlag = true
    state.addCorporation.pushNotificationEnableFlag = true
    state.addCorporation.spEnableFlag = true
    state.addCorporation.contactsEnableFlag = true
    state.addCorporation.callAvairableUserGetEnableFlag = true
    state.addCorporation.adminUsers = [
      {
        adminUserId: '',
        adminUserName: '',
        mailAddress: '',
        password: ''
      }
    ]
    state.addCorporation.patientInfoEnableFlag = false
    state.updateCorporation = JSON.parse(JSON.stringify(state.corporation))
  },
  setFlags(state, corporationFlags) {
    if (corporationFlags.locationInfoEnableFlag != null) {
      state.addCorporation.locationInfoEnableFlag =
        corporationFlags.locationInfoEnableFlag
      state.updateCorporation.locationInfoEnableFlag =
        corporationFlags.locationInfoEnableFlag
    } else {
      state.addCorporation.locationInfoEnableFlag = false
      state.updateCorporation.locationInfoEnableFlag = false
    }
    if (corporationFlags.gpsEnableFlag != null) {
      state.addCorporation.gpsEnableFlag = corporationFlags.gpsEnableFlag
      state.updateCorporation.gpsEnableFlag = corporationFlags.gpsEnableFlag
    } else {
      state.addCorporation.gpsEnableFlag = false
      state.updateCorporation.gpsEnableFlag = false
    }
    if (corporationFlags.mailTargetFlag != null) {
      state.addCorporation.mailTargetFlag = corporationFlags.mailTargetFlag
      state.updateCorporation.mailTargetFlag = corporationFlags.mailTargetFlag
    } else {
      state.addCorporation.mailTargetFlag = false
      state.updateCorporation.mailTargetFlag = false
    }
    if (corporationFlags.passwordEnableFlag != null) {
      state.addCorporation.passwordEnableFlag =
        corporationFlags.passwordEnableFlag
    } else {
      state.addCorporation.passwordEnableFlag = false
    }
    if (corporationFlags.autoLogoutEnableFlag != null) {
      state.addCorporation.autoLogoutEnableFlag =
        corporationFlags.autoLogoutEnableFlag
    } else {
      state.addCorporation.autoLogoutEnableFlag = false
    }
    if (corporationFlags.ratingQuarityEnableFlag != null) {
      state.addCorporation.ratingQuarityEnableFlag =
        corporationFlags.ratingQuarityEnableFlag
    } else {
      state.addCorporation.ratingQuarityEnableFlag = false
    }
    if (corporationFlags.pushNotificationEnableFlag != null) {
      state.addCorporation.pushNotificationEnableFlag =
        corporationFlags.pushNotificationEnableFlag
      state.updateCorporation.pushNotificationEnableFlag =
        corporationFlags.pushNotificationEnableFlag
    } else {
      state.addCorporation.pushNotificationEnableFlag = false
      state.updateCorporation.pushNotificationEnableFlag = false
    }
    if (corporationFlags.spEnableFlag != null) {
      state.addCorporation.spEnableFlag = corporationFlags.spEnableFlag
      state.updateCorporation.spEnableFlag = corporationFlags.spEnableFlag
    } else {
      state.addCorporation.spEnableFlag = false
      state.updateCorporation.spEnableFlag = false
    }
    if (corporationFlags.contactsEnableFlag != null) {
      state.addCorporation.contactsEnableFlag =
        corporationFlags.contactsEnableFlag
      state.updateCorporation.contactsEnableFlag =
        corporationFlags.contactsEnableFlag
    } else {
      state.addCorporation.contactsEnableFlag = false
      state.updateCorporation.contactsEnableFlag = false
    }
    if (corporationFlags.callAvairableUserGetEnableFlag != null) {
      state.addCorporation.callAvairableUserGetEnableFlag =
        corporationFlags.callAvairableUserGetEnableFlag
      state.updateCorporation.callAvairableUserGetEnableFlag =
        corporationFlags.callAvairableUserGetEnableFlag
    } else {
      state.addCorporation.callAvairableUserGetEnableFlag = false
      state.updateCorporation.callAvairableUserGetEnableFlag = false
    }
  },
  setCallAppList(state, callAppList) {
    state.addCorporation.callAppList = callAppList
    state.updateCorporation.callAppList = callAppList
  },
  setConstractDateTime(state, constractDate) {
    state.addCorporation.constractDate = constractDate
  },
  setRatesInfos(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    for (var j = 0; j < response.data['data'].length; j++) {
      response.data['data'][j]['checked'] = false
    }
    state.rates = response.data['data']
  },
  setLocationLogInfos(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    for (var j = 0; j < response.data['data'].length; j++) {
      response.data['data'][j]['checked'] = false
    }
    state.locationLogs = response.data['data']
  },
  setRateLogInfos(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    for (var j = 0; j < response.data['data'].length; j++) {
      response.data['data'][j]['checked'] = false
    }
    state.ratesLogs = response.data['data']
  },
  setUserInfos(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.users = response.data['data']
  },
  setPostInfos(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      response.data['data'][i]['checked'] = false
    }
    state.posts = response.data['data']
  },
  setCallAppDefine(state, response) {
    for (var i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    state.callAppDefine = response.data['data']
  },
  setUsageLogsAuditLog(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    state.usageLogsAuditLog = response.data['data']
  },
  setUsageLogsCallHistory(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    state.usageLogsCallHistory = response.data['data']
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/systemAdminModules/companiesModules/companiesMutation.js